(function () {
  // ====== CONFIG - fill these in ======
  const SUPABASE_FUNCTION_URL = "https://lxxvnakbvshpnkesxvdy.supabase.co/functions/v1/support-chat";
  const SUPABASE_ANON_KEY = "sb_publishable_LQ3gdeNeq6Ou5hcykM47Rw_7j4XfTxS";
  // =====================================

  const sessionId = (() => {
    let id = localStorage.getItem("ll_chat_session");
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("ll_chat_session", id);
    }
    return id;
  })();

  let history = JSON.parse(sessionStorage.getItem("ll_chat_history") || "[]");

  // ---------- Styles ----------
  const style = document.createElement("style");
  style.textContent = `
    #ll-chat-bubble {
      position: fixed; bottom: 20px; right: 20px; width: 60px; height: 60px;
      border-radius: 50%; background: #000; color: white; display: flex;
      align-items: center; justify-content: center; cursor: pointer; z-index: 999999;
      box-shadow: 0 4px 14px rgba(0,0,0,0.3); border: none; transition: transform 0.15s ease;
    }
    #ll-chat-bubble:hover { transform: scale(1.06); }
    #ll-chat-bubble svg {
      width: 26px; height: 26px; position: absolute;
      transition: opacity 0.15s ease, transform 0.15s ease;
    }
    #ll-chat-bubble .ll-icon-chat { opacity: 1; transform: scale(1) rotate(0deg); }
    #ll-chat-bubble .ll-icon-close { opacity: 0; transform: scale(0.6) rotate(-45deg); }
    #ll-chat-bubble.open .ll-icon-chat { opacity: 0; transform: scale(0.6) rotate(45deg); }
    #ll-chat-bubble.open .ll-icon-close { opacity: 1; transform: scale(1) rotate(0deg); }

    @keyframes ll-pulse-ring {
      0% { box-shadow: 0 4px 14px rgba(0,0,0,0.3), 0 0 0 0 rgba(0,0,0,0.28); }
      70% { box-shadow: 0 4px 14px rgba(0,0,0,0.3), 0 0 0 12px rgba(0,0,0,0); }
      100% { box-shadow: 0 4px 14px rgba(0,0,0,0.3), 0 0 0 0 rgba(0,0,0,0); }
    }
    #ll-chat-bubble.ll-attention { animation: ll-pulse-ring 1.8s ease-out 3; }

    #ll-chat-window {
      position: fixed; bottom: 92px; right: 20px; width: 360px; max-width: 90vw;
      height: 480px; max-height: 70vh; background: #fff; border-radius: 14px;
      border: 1px solid #e8e8e8; box-shadow: 0 12px 32px rgba(0,0,0,0.14);
      display: flex; flex-direction: column; overflow: hidden; z-index: 999999;
      font-family: system-ui, -apple-system, sans-serif;
      opacity: 0; transform: translateY(12px) scale(0.98); pointer-events: none;
      transform-origin: bottom right; transition: opacity 0.18s ease, transform 0.18s ease;
    }
    #ll-chat-window.open { opacity: 1; transform: translateY(0) scale(1); pointer-events: auto; }

    #ll-chat-header {
      background: #000; color: #fff; padding: 16px 18px;
      display: flex; justify-content: space-between; align-items: center;
    }
    #ll-chat-header .ll-title { font-weight: 700; font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; }
    #ll-chat-close { cursor: pointer; opacity: 0.7; font-size: 16px; line-height: 1; }
    #ll-chat-close:hover { opacity: 1; }

    #ll-chat-messages { flex: 1; overflow-y: auto; padding: 14px; background: #fafafa; }
    .ll-msg { margin-bottom: 10px; max-width: 82%; padding: 10px 13px; border-radius: 12px; font-size: 14px; line-height: 1.45; }
    .ll-msg.user { background: #000; color: #fff; margin-left: auto; border-bottom-right-radius: 3px; }
    .ll-msg.assistant { background: #fff; color: #1a1a1a; border: 1px solid #e5e5e5; border-bottom-left-radius: 3px; }

    #ll-chat-input-row { display: flex; align-items: center; gap: 8px; border-top: 1px solid #eee; padding: 10px; background: #fff; }
    #ll-chat-input { flex: 1; border: 1px solid #e0e0e0; border-radius: 20px; outline: none; font-size: 14px; padding: 9px 14px; }
    #ll-chat-input:focus { border-color: #000; }
    #ll-chat-send {
      background: #000; color: white; border: none; border-radius: 50%; width: 34px; height: 34px;
      display: flex; align-items: center; justify-content: center; cursor: pointer; flex-shrink: 0;
    }
    #ll-chat-send svg { width: 16px; height: 16px; }
    #ll-chat-send:disabled { opacity: 0.3; cursor: default; }

    .ll-typing-dots {
      display: inline-flex; align-items: center; gap: 3px; background: #fff; border: 1px solid #e5e5e5;
      border-radius: 12px; border-bottom-left-radius: 3px; padding: 10px 13px; margin-bottom: 10px;
    }
    .ll-typing-dots span { width: 6px; height: 6px; border-radius: 50%; background: #999; animation: ll-bounce 1.2s infinite ease-in-out; }
    .ll-typing-dots span:nth-child(2) { animation-delay: 0.15s; }
    .ll-typing-dots span:nth-child(3) { animation-delay: 0.3s; }
    @keyframes ll-bounce {
      0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
      30% { transform: translateY(-4px); opacity: 1; }
    }
    .ll-msg a {
      display: inline-flex; align-items: center; gap: 5px;
      margin-top: 8px; padding: 7px 14px;
      background: #000; color: #fff !important; text-decoration: none;
      border-radius: 999px; font-size: 12px; font-weight: 700;
      letter-spacing: 0.04em; text-transform: uppercase;
      transition: background 0.15s ease;
    }
    .ll-msg a:hover { background: #333; }
    .ll-msg a::after { content: "\\2192"; font-size: 13px; line-height: 1; }
  `;
  document.head.appendChild(style);

  // ---------- DOM ----------
  const bubble = document.createElement("button");
  bubble.id = "ll-chat-bubble";
  bubble.setAttribute("aria-label", "Chat with Luma");
  bubble.innerHTML = `
    <svg class="ll-icon-chat" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4.5h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9.5l-4.8 3.8A.5.5 0 0 1 4 20.9V17.5H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2z"
        stroke="white" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
      <path d="M12.5 8l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1z" fill="white"/>
    </svg>
    <svg class="ll-icon-close" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6l12 12M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `;
  document.body.appendChild(bubble);

  const win = document.createElement("div");
  win.id = "ll-chat-window";
  win.innerHTML = `
    <div id="ll-chat-header">
      <span class="ll-title">Luma</span>
      <span id="ll-chat-close">&#10005;</span>
    </div>
    <div id="ll-chat-messages"></div>
    <div id="ll-chat-input-row">
      <input id="ll-chat-input" type="text" placeholder="Ask about your order, setup, returns..." />
      <button id="ll-chat-send" aria-label="Send">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19V5M12 5L6 11M12 5l6 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  `;
  document.body.appendChild(win);

  const messagesEl = win.querySelector("#ll-chat-messages");
  const inputEl = win.querySelector("#ll-chat-input");
  const sendBtn = win.querySelector("#ll-chat-send");

  function renderHistory() {
    messagesEl.innerHTML = "";
    for (const m of history) {
      addBubble(m.role, typeof m.content === "string" ? m.content : "");
    }
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function linkify(escapedText) {
    // Single pass, single regex with alternation - either a [label](url) markdown link OR a bare
    // lumalanes.com URL. Doing this in one pass is essential: a second separate pass over the
    // already-substituted HTML would re-match the URL sitting inside the href="..." attribute
    // we just inserted and corrupt it with a nested tag.
    // (?<!\S@) stops a bare match from firing when the domain is actually part of an
    // email address, e.g. "cameron@lumalanes.com" should stay plain text, not become a link.
    const combinedRegex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+?)["')]*\)|(?<!\S@)((?:https?:\/\/)?(?:www\.)?lumalanes\.com[^\s<]*)/g;
    return escapedText.replace(combinedRegex, (match, label, mdUrl, bareUrl) => {
      if (label && mdUrl) {
        const cleanUrl = mdUrl.replace(/["'.,;:]+$/, "");
        return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">${label}</a>`;
      }
      if (bareUrl) {
        const cleanBare = bareUrl.replace(/["'.,;:]+$/, "");
        const href = /^https?:\/\//i.test(cleanBare) ? cleanBare : "https://" + cleanBare;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${cleanBare}</a>`;
      }
      return match;
    });
  }

  function addBubble(role, text) {
    const div = document.createElement("div");
    div.className = "ll-msg " + (role === "user" ? "user" : "assistant");
    if (role === "assistant") {
      div.innerHTML = linkify(escapeHtml(text)).replace(/\n/g, "<br>");
    } else {
      div.textContent = text;
    }
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  if (history.length === 0) {
    addBubble("assistant", "Hey, I'm Luma — your AI LumaLanes guru. Ask me anything about our products, orders, setup, returns, or the buying process.");
  } else {
    renderHistory();
  }

  // Draw the eye to the bubble once, a couple seconds after page load, until it's been clicked.
  if (!localStorage.getItem("ll_seen_bubble")) {
    setTimeout(() => bubble.classList.add("ll-attention"), 2000);
  }

  bubble.addEventListener("click", () => {
    localStorage.setItem("ll_seen_bubble", "1");
    bubble.classList.remove("ll-attention");
    const isOpen = win.classList.toggle("open");
    bubble.classList.toggle("open", isOpen);
    if (isOpen) {
      setTimeout(() => inputEl.focus(), 200);
    }
  });
  win.querySelector("#ll-chat-close").addEventListener("click", () => {
    win.classList.remove("open");
    bubble.classList.remove("open");
  });

  async function sendMessage() {
    const text = inputEl.value.trim();
    if (!text) return;
    inputEl.value = "";
    sendBtn.disabled = true;

    addBubble("user", text);

    const typing = document.createElement("div");
    typing.className = "ll-typing-dots";
    typing.innerHTML = "<span></span><span></span><span></span>";
    messagesEl.appendChild(typing);
    messagesEl.scrollTop = messagesEl.scrollHeight;

    try {
      const res = await fetch(SUPABASE_FUNCTION_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ message: text, session_id: sessionId, history }),
      });
      const data = await res.json();
      typing.remove();

      const reply = data.reply || "Sorry, something went wrong - please try again in a moment.";
      addBubble("assistant", reply);

      history.push({ role: "user", content: text });
      history.push({ role: "assistant", content: reply });
      sessionStorage.setItem("ll_chat_history", JSON.stringify(history));
    } catch (e) {
      typing.remove();
      addBubble("assistant", "Sorry, I'm having trouble connecting. Please try again shortly.");
    } finally {
      sendBtn.disabled = false;
    }
  }

  sendBtn.addEventListener("click", sendMessage);
  inputEl.addEventListener("keydown", (e) => {
    if (e.key === "Enter") sendMessage();
  });
})();